import { lazy } from "react";
import { Navigate, RouteObject } from "react-router-dom";

import { FaceId } from "@/modules/yetakchi/attendance/ui/face-id";

import YouthRegisterLayout from "@/layout/YouthRegister";

const ProfileLayout = lazy(() =>
  import("@/modules/yetakchi/profile/ui/ProfileLayout").then((res) => ({
    default: res.ProfileLayout,
  })),
);
const EmploymentHistory = lazy(() =>
  import("@/pages/Protected/Yetakchi/Profile/EmploymentHistory").then(
    (res) => ({
      default: res.EmploymentHistory,
    }),
  ),
);
const Education = lazy(() =>
  import("@/pages/Protected/Yetakchi/Profile/Education").then((res) => ({
    default: res.Education,
  })),
);
const Awards = lazy(() =>
  import("@/pages/Protected/Yetakchi/Profile/Awards").then((res) => ({
    default: res.Awards,
  })),
);
const Attendence = lazy(
  () => import("@/pages/Protected/Yetakchi/Attendence/Attendence"),
);
const MyVillageRoot = lazy(
  () => import("@/pages/Protected/Yetakchi/neighorbood/MyVillage"),
);

const YouthRegister = lazy(
  () => import("@/pages/Protected/Yetakchi/YouthRegister"),
);
const Tasks = lazy(() => import("@/pages/Protected/Yetakchi/Tasks/Tasks"));
const TaskReportRoot = lazy(
  () => import("@/pages/Protected/Yetakchi/Tasks/TaskReport"),
);
const TaskCalendar = lazy(
  () => import("@/pages/Protected/Yetakchi/Tasks/Calendar"),
);
const ProfileRequests = lazy(
  () => import("@/pages/Protected/Yetakchi/Profile/application"),
);
const Application = lazy(
  () => import("@/pages/Protected/Yetakchi/Profile/Application/index"),
);
const TaskDetails = lazy(
  () => import("@/pages/Protected/Yetakchi/Tasks/TaskDetail"),
);
const AttendenceIn = lazy(
  () => import("@/pages/Protected/Yetakchi/Attendence/In"),
);
const AttendenceOut = lazy(
  () => import("@/pages/Protected/Yetakchi/Attendence/Out"),
);
const AttendenceReason = lazy(
  () => import("@/pages/Protected/Yetakchi/Attendence/form"),
);
const OffSite = lazy(
  () => import("@/pages/Protected/Yetakchi/Attendence/OffSite"),
);
const AttendenceStatistics = lazy(
  () => import("@/pages/Protected/Yetakchi/Attendence/Statistics"),
);
const Projects = lazy(
  () => import("@/pages/Protected/Yetakchi/Profile/projects"),
);
// const ChatPage = lazy(() => import("@/modules/admin/pages/Chat"));
// const ChatMessages = lazy(() => import("@/modules/admin/pages/ChatMessages"));
// const NewChatMessages = lazy(() => import("@/modules/admin/pages/NewChatMessages"));
const RatingKpi = lazy(
  () => import("@/pages/Protected/Yetakchi/Profile/rating"),
);
const AnnouncementNews = lazy(
  () => import("@/pages/Protected/Yetakchi/NotificationNews"),
);
const AnnouncementRoot = lazy(
  () => import("@/pages/Protected/Yetakchi/NotificationNews/Announcement"),
);
const NewsRoot = lazy(
  () => import("@/pages/Protected/Yetakchi/NotificationNews/News"),
);
const Dashboard = lazy(() => import("@/pages/Protected/Yetakchi/Dashboard"));
const Unemployed = lazy(
  () => import("@/pages/Protected/Yetakchi/neighorbood/Unemployed"),
);
const CriminalYouths = lazy(
  () => import("@/pages/Protected/Yetakchi/neighorbood/CriminalYouths"),
);
export const yetakchiDashboard: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="/yetakchi/dashboard" />,
  },
  {
    path: "dashboard",
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "profile",
        element: <ProfileLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="requests" replace />,
          },
          {
            path: "employment",
            element: <EmploymentHistory />,
          },
          {
            path: "education",
            element: <Education />,
          },
          {
            path: "achievements",
            element: <Awards />,
          },
          {
            path: "requests",
            element: <ProfileRequests />,
          },
          {
            path: "projects",
            element: <Projects />,
          },
          {
            path: "kpi",
            element: <RatingKpi />,
          },
        ],
      },
      {
        path: "send-request",
        element: <Application />,
      },
      {
        path: "attendance",
        element: <Attendence />,
        children: [
          {
            index: true,
            element: <Navigate to="/yetakchi/dashboard/attendance/in" />,
          },
          {
            path: "in",
            element: <AttendenceIn />,
          },
          {
            path: "out",
            element: <AttendenceOut />,
          },
          {
            path: "reason",
            element: <AttendenceReason />,
          },
          {
            path: "statistics",
            element: <AttendenceStatistics />,
          },
          {
            path: "in/face-id",
            element: <FaceId />,
          },
          {
            path: "out/face-id",
            element: <FaceId />,
          },
          {
            path: "off-site",
            element: <OffSite />,
          },
          {
            path: "off-site/face-id",
            element: <FaceId />,
          },
        ],
      },
      {
        path: "my-neighborhood",
        children: [
          {
            index: true,
            element: <MyVillageRoot />,
          },
          {
            path: "unemployed",
            element: <Unemployed />,
          },
          {
            path: "criminal-youths",
            element: <CriminalYouths />,
          },
        ],
      },
      {
        path: "youth-register",
        element: <YouthRegisterLayout />,
        children: [
          {
            index: true,
            element: <YouthRegister />,
          },
        ],
      },
      {
        path: "tasks",
        children: [
          {
            index: true,
            element: <TaskCalendar />,
          },
          {
            path: "report",
            element: <TaskReportRoot />,
          },
          {
            path: "detail",
            element: <Tasks />,
            children: [
              {
                path: ":id",
                element: <TaskDetails />,
              },
            ],
          },
        ],
      },
      {
        path: "projects",
        element: <Projects />,
      },
      {
        path: "requests",
        element: <ProfileRequests />,
      },
      //   {
      //     path: "chat",
      //     element: (
      //       //   <RoleGuard
      //       //     redirectTo="/dashboard/tasks"
      //       //     restrictedRoles={[UserRole.InstitutionLeader]}
      //       //   >
      //       <ChatPage />
      //       //   </RoleGuard>
      //     ),
      //     children: [
      //       {
      //         path: ":id/:user_id",
      //         element: (
      //           //   <RoleGuard
      //           //     redirectTo="/dashboard/tasks"
      //           //     restrictedRoles={[UserRole.InstitutionLeader]}
      //           //   >
      //           <ChatMessages />
      //           //   </RoleGuard>
      //         ),
      //       },
      //       {
      //         path: "new/:user_id",
      //         element: (
      //           //   <RoleGuard
      //           //     redirectTo="/dashboard/tasks"
      //           //     restrictedRoles={[UserRole.InstitutionLeader]}
      //           //   >
      //           <NewChatMessages />
      //           //   </RoleGuard>
      //         ),
      //       },
      //     ],
      //   },
      // --- Leader-only: Balance ---
      // {
      //   path: "balance",
      //   children: [
      //     {
      //       index: true,
      //       element: (
      //         <RoleGuard
      //           restrictedRoles={[
      //             UserRole.DepartmentAdmin,
      //             UserRole.DistrictAdmin,
      //             UserRole.RegionAdmin,
      //           ]}
      //           redirectTo="/yetakchi/dashboard"
      //         >
      //           <Balance />
      //         </RoleGuard>
      //       ),
      //     },
      //     {
      //       path: "edit",
      //       element: (
      //         <RoleGuard
      //           restrictedRoles={[
      //             UserRole.DepartmentAdmin,
      //             UserRole.DistrictAdmin,
      //             UserRole.RegionAdmin,
      //           ]}
      //           redirectTo="/yetakchi/dashboard"
      //         >
      //           <BalanceEdit />
      //         </RoleGuard>
      //       ),
      //     },
      //     {
      //       path: "stats/:category",
      //       element: (
      //         <RoleGuard
      //           restrictedRoles={[
      //             UserRole.DepartmentAdmin,
      //             UserRole.DistrictAdmin,
      //             UserRole.RegionAdmin,
      //           ]}
      //           redirectTo="/yetakchi/dashboard"
      //         >
      //           <StatsDetailPage />
      //         </RoleGuard>
      //       ),
      //     },
      //   ],
      // },
      {
        path: "notification-news",
        element: <AnnouncementNews />,
        children: [
          {
            index: true,
            element: <AnnouncementRoot />,
          },
          {
            path: "news",
            element: <NewsRoot />,
          },
        ],
      },
      // --- Leader-only: Mega Projects ---
      // {
      //   path: "mega-projects",
      //   element: (
      //     <RoleGuard
      //       restrictedRoles={[
      //         UserRole.DepartmentAdmin,
      //         UserRole.DistrictAdmin,
      //         UserRole.RegionAdmin,
      //       ]}
      //       redirectTo="/yetakchi/dashboard/tasks"
      //     >
      //       <MegaProjects />
      //     </RoleGuard>
      //   ),
      // },
    ],
  },
];
